module.exports = __webpack_public_path__ + "img/skulpturen1.915e0653.jpg";